import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { defaultDataIdFromObject, InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

import { createDebug } from '../utils/runtimeDebug';

import { getUrlResolverError, getNetworkErrors, GqlErrors } from './apolloClientErrorHandlers';

const debug = createDebug('getBrowserApolloClient');

/**
 * @param links
 * @param unionAndInterfaceTypes
 * @param initialState
 */
export function getBrowserApolloClient(
    links: ApolloLink[],
    unionAndInterfaceTypes = {},
    initialState?: any,
): [ApolloClient<any>, () => GqlErrors[]] {
    const errors: GqlErrors[] = [];

    const urlResolverError = getUrlResolverError(errors, debug);
    const networkErrors = getNetworkErrors(errors);
    const fragmentMatcher = new IntrospectionFragmentMatcher({
        introspectionQueryResultData: unionAndInterfaceTypes as any,
    });

    return [
        new ApolloClient({
            link: ApolloLink.from([urlResolverError, networkErrors, ...links]),
            cache: new InMemoryCache({
                dataIdFromObject: (object: any) => {
                    switch (object.__typename) {
                        case 'EntityUrl':
                            return `${object.type}-${object.id}`; // use `type + id` as the primary key
                        default:
                            return defaultDataIdFromObject(object); // fall back to default handling
                    }
                },
                fragmentMatcher,
            }).restore(initialState),
        }),
        () => errors,
    ];
}
